export default __webpack_public_path__ + "df686ba9c0f96f2ee2cf06783663922f.gif";